import React from 'react';
import { Typography } from 'antd';
import PageWrapper from '../components/layout/PageWrapper';
import ExternalLink from '../components/ExternalLink';
import { CONTACT_PHONE } from '../constants';


const { Title, Paragraph, Text } = Typography;

const FaqsPage = () => {
    return (
        <PageWrapper>
            <Title level={2}>
                FAQs
            </Title>
            <Title level={4}>
                What happens after I make a booking?
            </Title>
            <Paragraph>
                After booking your appointment slot, you will receive a confirmation email containing the details of your booking. If the email data contained does not match the information you have
                supplied, please contact us immediately.
            </Paragraph>
            <Title level={4}>
                Why haven't I received a confirmation email?
            </Title>
            <Paragraph>
                If you haven't received a confirmation email, please let us know immediately.
            </Paragraph>
            <Title level={4}>
                How do you process payments?
            </Title>
            <Paragraph>
                All of our payments are handled and processed through <ExternalLink urlKey="STRIPE">Stripe</ExternalLink> to ensure a safe, reliable checkout process.
            </Paragraph>
            <Title level={4}>
                How do I amend my booking?
            </Title>
            <Paragraph>
                Your confirmation email will contain a unique link which will allow you to amend the date and time of your booking.
            </Paragraph>
            <Title level={4}>
                What is your refunds policy?
            </Title>
            <Paragraph>
                Cancellations with over 48hrs notice will result in a full refund (minus the booking charge). Refunds will <Text strong>not</Text> be provided to any cancellations within the 48hr period.
            </Paragraph>
            <br />
            <br />
            <Paragraph>
                If you have any queries regarding your booking, please do not hesitate to contact us on { CONTACT_PHONE }.
            </Paragraph>
        </PageWrapper>
    );
};

export default FaqsPage;
